import { inventoryActions } from '../actions'

const {
  FETCH_INVENTORY_INPUT_LIST,
  FETCHING_INVENTORY_INPUT_LIST,
  ADDING_INVENTORY_INPUT,
  ADD_INVENTORY_INPUT,
  ADD_INVENTORY_INPUT_ERROR,
  ADDING_INVENTORY_OUTPUT,
  ADD_INVENTORY_OUTPUT,
  ADD_INVENTORY_OUTPUT_ERROR,
  FETCHING_DOWNLOAD_XLS,
  FETCH_DOWNLOAD_XLS,
  FETCH_DOWNLOAD_XLS_ERROR,
  FETCHING_DOWNLOAD_PDF,
  FETCH_DOWNLOAD_PDF,
  FETCH_DOWNLOAD_PDF_ERROR,
  EDITING_INVENTORY_INPUT,
  EDIT_INVENTORY_INPUT,
  EDIT_INVENTORY_INPUT_ERROR,
  FETCH_INVENTORY_HISTORIC,
  FETCHING_INVENTORY_HISTORIC,
  FETCHING_HISTORIC_DOWNLOAD,
  FETCH_HISTORIC_DOWNLOAD,
  FETCH_HISTORIC_DOWNLOAD_ERROR,
  FETCHING_PRODUCT_HISTORIC_DOWNLOAD,
  FETCH_PRODUCT_HISTORIC_DOWNLOAD,
  FETCH_PRODUCT_HISTORIC_DOWNLOAD_ERROR,
  CHANGE_STATUS_DOWNLOAD_ERROR
} = inventoryActions

const initialState = {
  fetching: {
    inventoryInputList: false,
    download: false,
    inventoryHistoric: false
  },
  items: [],
  pagination: {},
  last_update: '',
  total_records: '',
  fetch_errors: {
    inventoryInputList: false,
    download: false,
    inventoryHistoric: false
  },
  areaResponsibleUser: null,
  unitResponsibleUser: null
}

const inventory = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_INVENTORY_INPUT_LIST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          inventoryInputList: action.value
        }
      }

    case FETCH_INVENTORY_INPUT_LIST:
      return {
        ...state,
        last_update: action.last_update,
        total_records: action.total_records,
        items: action.items,
        pagination: action.pagination,
        fetching: {
          ...state.fetching,
          inventoryInputList: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          inventoryInputList: false
        }
      }

    case FETCHING_INVENTORY_HISTORIC:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          inventoryHistoric: action.value
        }
      }

    case FETCH_INVENTORY_HISTORIC:
      return {
        ...state,
        last_update: action.last_update,
        items: action.items,
        total_records: action.total_records,
        pagination: action.pagination,
        fetching: {
          ...state.fetching,
          inventoryHistoric: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          iventoryHistoric: false
        }
      }

    case ADDING_INVENTORY_INPUT:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          inventoryInputList: action.value
        },
        fetch_errors: {
          ...state.fetch_errors,
          inventoryInputList: false
        }
      }

    case ADD_INVENTORY_INPUT:
      return {
        ...state,
        items: action.items,
        last_update: action.last_update,
        pagination: action.pagination,
        fetching: {
          ...state.fetching,
          inventoryInputList: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          inventoryInputList: false
        }
      }

    case ADD_INVENTORY_INPUT_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          inventoryInputList: false
        }
      }

    case ADDING_INVENTORY_OUTPUT:
      return {
        ...state,

        fetching: {
          ...state.fetching,
          inventoryInputList: action.value
        },
        fetch_errors: {
          ...state.fetch_errors,
          inventoryInputList: false
        }
      }

    case ADD_INVENTORY_OUTPUT:
      return {
        ...state,
        last_update: action.last_update,
        items: action.items,
        pagination: action.pagination,
        fetching: {
          ...state.fetching,
          inventoryInputList: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          inventoryInputList: false
        }
      }

    case ADD_INVENTORY_OUTPUT_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          inventoryInputList: false
        }
      }

    case FETCHING_DOWNLOAD_XLS:
      return {
        ...state,
        fetching: {
          download: true
        }
      }

    case FETCH_DOWNLOAD_XLS:
      return {
        ...state,
        fetching: {
          download: false
        }
      }

    case FETCH_DOWNLOAD_XLS_ERROR:
      return {
        ...state,
        fetching: {
          download: false
        },
        fetch_errors: {
          download: true
        }
      }

    case FETCHING_DOWNLOAD_PDF:
      return {
        ...state,
        fetching: {
          download: true
        }
      }

    case FETCH_DOWNLOAD_PDF:
      return {
        ...state,
        fetching: {
          download: false
        }
      }

    case FETCH_DOWNLOAD_PDF_ERROR:
      return {
        ...state,
        fetching: {
          download: false
        },
        fetch_errors: {
          download: true
        }
      }

    case CHANGE_STATUS_DOWNLOAD_ERROR:
      return {
        ...state,
        fetch_errors: {
          download: false
        }
      }

    case EDITING_INVENTORY_INPUT:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          inventoryInputList: action.value
        },
        fetch_errors: {
          ...state.fetch_errors,
          inventoryInputList: false
        }
      }
  
    case EDIT_INVENTORY_INPUT:
      return {
        ...state,
        last_update: action.last_update,
        items: action.items,
        pagination: action.pagination,
        fetching: {
          ...state.fetching,
          inventoryInputList: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          inventoryInputList: false,
          download: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          download: false
        }
      }

    case EDIT_INVENTORY_INPUT_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          inventoryInputList: false
        },
        fetch_errors: {
          inventoryInputList: true
        }
      }

    case CHANGE_STATUS_DOWNLOAD_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          download: false
        }
      }

    case FETCHING_HISTORIC_DOWNLOAD:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          download: true
        }
      }

    case FETCH_HISTORIC_DOWNLOAD:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          download: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          download: false
        }
      }

    case FETCH_HISTORIC_DOWNLOAD_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          download: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          download: true
        }
      }

    case FETCHING_PRODUCT_HISTORIC_DOWNLOAD:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          download: true
        }
      }

    case FETCH_PRODUCT_HISTORIC_DOWNLOAD:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          download: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          download: false
        }
      }

    case FETCH_PRODUCT_HISTORIC_DOWNLOAD_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          download: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          download: true
        }
      }

    case CHANGE_STATUS_DOWNLOAD_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          download: false
        }
      }
    
    default:
      return state
  }
}

export default inventory



// WEBPACK FOOTER //
// ./src/reducers/inventory.js